import React from 'react'
import { observer } from 'mobx-react'

import {
  Section,
  SectionContent,
  SectionHeader,
  useSection,
} from 'components/Section'
import BookkeepingPendingAction from 'admin/bookkeeping/BookkeepingPendingAction'
import Avatar from 'components/Avatar'
import Member from 'iam/models/Member'

import styles from './ProviderSection.sass'

interface ProviderSectionProps {
  vm: BookkeepingPendingAction
}

export default observer(function ProviderSection({ vm }: ProviderSectionProps) {
  const sectionProps = useSection(false)

  return (
    <Section {...sectionProps}>
      <SectionHeader>Assigned Pro</SectionHeader>

      <SectionContent>
        {vm.championPro && <ProviderItem provider={vm.championPro} />}
      </SectionContent>
    </Section>
  )
})

interface ProviderItemProps {
  provider: Member
}

function ProviderItem({ provider }: ProviderItemProps) {
  return (
    <div className={styles.root}>
      <Avatar subject={provider} size={24}></Avatar>
      <div className={styles.provider}>
        <div className={styles.username}>{provider.displayName}</div>
        <div className={styles.email}>{provider.email}</div>
      </div>
    </div>
  )
}
